<div class="page-container">
  <div class="header">
    <a [href]=homeUrl class="header-title">{{ 'jecrm' | translate }}</a>
  </div>

  <div class="content">
    <div class="content-card">
      <img class="integration-logo" src="{{ integrationActionData.actionIcon }}" alt="Integration action">
      <h1 class="title">{{ integrationActionData.title }}</h1>
      <app-button btnType="raised" (onChangeClick)="onNext()">{{ 'next' | translate }}</app-button>
    </div>
  </div>

</div>
